import { defineMessages } from 'react-intl';

export default defineMessages({
    lblSmsWillBeSent: {
        id: 'app.booking.sendToSms.smsWillBeSent',
        defaultMessage: 'A text message containing ticket information will be sent to the following phone number:',
    },
});
